<template>
  <div class="fill-height">
    <iframe id="ml_presentation_iframe"
            :src="url"
            class="CL_frame"
            width="100%"
            height="100%"
            allow="camera *;fullscreen"
            allowfullscreen>
    </iframe>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  name: 'view-html-presentation',
  props: {
    presentation: {
      type: Object,
      required: true,
    },
    session: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    url() {
      return this.$route.query.url;
    }
  },
  methods: {}
}
</script>
